import client from '../httpClient';

// 【sendmail010】メール作成時署名取得
const sendmailGetDefaultApi = (params) => {
  return client.get('/send-mails/default/', { params });
};

export default sendmailGetDefaultApi;
